module.exports = __webpack_public_path__ + "img/multiPlane.a7fafc74.png";